import { ELocalStorageKeys } from '@web-store-platforms/types';

export const DEV_API_MOCK_COOKIE_VALUE = '1';

export const API_MOCK_QUERY_KEYS = {
    boot: ['boot'] as const,
    offers: ['offers'] as const,
    template: ['publisherTemplate'] as const,
} as const;

export const API_MOCK_STORAGE_KEYS = {
    boot: ELocalStorageKeys.MOCK_BOOT_API,
    offers: ELocalStorageKeys.MOCK_OFFERS_API,
    template: ELocalStorageKeys.MOCK_TEMPLATE_API,
} as const;
